export const SignedUpNewsletterSwrFetchKey = "signedUpNewsletters";

// V1 keys
export const SignedUpNewsletterV1LocalStorageKey = "subscribed_newsletters";
export const SignedUpLastSyncKey = "signedUpNewslettersUpdateTimeV2";

export const ResetAfterSuccessTimeout = 10_000;
